import * as React from 'react';

import styles from './styles.css';

export const CpdInfoSection: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['section']}>
      <div className={styles['row']}>{children}</div>
    </div>
  );
};
